module.exports = __webpack_public_path__ + "img/logo_hamamatsu-iwata@2x.a4e5938c.svg";